import { getCurrentCountryCode } from './getCurrentCountryCode';

export const getLinkPrefix = (type, url) => {
  const types = ['articles', 'categories', 'subcategories'];

  if (type && url && types.includes(type)) {
    return `/${getCurrentCountryCode()}/${type}/${url}`;
  }
  return `/${type}/${url}`;
}